import { SPELL_ID } from '../ids/spell-id'
import { SpellMap } from 'web/data/models'
import { MODIFIER_ID } from '../ids/modifier-id'
import { TALENT_ID } from '../ids/talent-id'
import { SHAMAN_TALENTS } from '../talents/shaman'
import { copyTalentPropsToSpell } from 'web/data/core-data'

export const SHAMAN_SPELLS: SpellMap = {

    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#
    //
    // Resto
    //
    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#

    [SPELL_ID.SHAMAN.RESTO.HTT]: {
        id: SPELL_ID.SHAMAN.RESTO.HTT,
        talentId: undefined,

        name: "Healing Tide Totem",
        shortName: "HTT",

        cooldown: 180,
        affectedByModifierIds: [MODIFIER_ID.ESSENCE_VOP],

        game_id: 108280,
        icon_name: "ability_shaman_healingtide",
    },

    [SPELL_ID.SHAMAN.RESTO.SLT]: {
        id: SPELL_ID.SHAMAN.RESTO.SLT,
        talentId: undefined,

        name: "Spirit Link Totem",
        shortName: "SLT",

        cooldown: 180,
        affectedByModifierIds: [],

        game_id: 98008,
        icon_name: "spell_shaman_spiritlink",
    },

    [SPELL_ID.SHAMAN.RESTO.APT]: {
        id: SPELL_ID.SHAMAN.RESTO.APT,
        cooldown: 300,
        affectedByModifierIds: [],

        ...copyTalentPropsToSpell(SHAMAN_TALENTS[TALENT_ID.SHAMAN.RESTO.APT])
    },

    [SPELL_ID.SHAMAN.RESTO.WRT]: {
        id: SPELL_ID.SHAMAN.RESTO.WRT,
        cooldown: 120,
        affectedByModifierIds: [],

        ...copyTalentPropsToSpell(SHAMAN_TALENTS[TALENT_ID.SHAMAN.RESTO.WRT])
    },

}
